import { render } from "./Finalize.vue?vue&type=template&id=639ad23d"
import script from "./Finalize.vue?vue&type=script&lang=js"
export * from "./Finalize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__